import { Chip, IconButton, Table, Text } from '@nimbus-ds/components';
import { Stack } from 'commons/components';
import useTranslationShipping from 'domains/Shipping/useTranslationShipping';

function Skeleton(): JSX.Element {
  const t = useTranslationShipping('deliveryMethods.shippingLimiting.listPage');

  return (
    <Table>
      <Table.Head>
        <Table.Row>
          <Table.Cell as="th">{t('table.shippingMethod')}</Table.Cell>
          <Table.Cell as="th">{t('table.activeRestrictions')}</Table.Cell>
          <Table.Cell as="th" width="10%">
            {t('table.actions')}
          </Table.Cell>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {[1, 2, 3].map((index) => (
          <Table.Row key={index}>
            <Table.Cell>
              <Text.Skeleton width="200px" />
            </Table.Cell>
            <Table.Cell>
              <Stack spacing="tight">
                <Chip.Skeleton />
                <Chip.Skeleton />
                <Chip.Skeleton />
              </Stack>
            </Table.Cell>
            <Table.Cell>
              <Stack spacing="tight">
                <IconButton.Skeleton />
                <IconButton.Skeleton />
              </Stack>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
}

export default Skeleton;
